<div class="container">
  <!-- Close button -->
  <button
    mat-icon-button
    class="top-close-btn"
    (click)="onClose()"
    aria-label="Close"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-content class="popup-content">

    <!-- MACRO LIST -->
    <div
      class="macro-buttons"
      role="list"
      *ngIf="hasMacros; else noMacroState"
    >
      <button
        type="button"
        class="macro-button"
        *ngFor="let macro of macros"
        (click)="onMacroClick(macro)"
        matTooltip="{{ macro.action }}"
        matTooltipPosition="right"
        role="listitem"
      >
        {{ macro.name }}
      </button>
    </div>

    <!-- NO MACRO STATE -->
    <ng-template #noMacroState>
      <div class="no-macro">
        No macro found
      </div>
    </ng-template>

  </div>
</div>
